// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3821
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";

// Event_name: 'shown.assistant_response'
// Description: When Answer and Assistant responses are shown, this event will be triggered
// Owner: dash-assist
export type Shown_AssistantResponse = PAPEventGeneric<
  'dash',
  'shown',
  'assistant_response',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // randomly generated uuid v4 for a Dash Answers conversation
    conversationId?: string;
    // The LLM-generated answer string returned from dash answers (Q&A) service.
    // This is L0 data, and will be copied to restricted_otc hive table according to this TDD: https://www.dropbox.com/scl/fi/0r38gxrobgr6yvrft4yzu/OTCUS-Machine-Learning-Restricted-Logging-via-PAP-TDD.paper?dl=0&rlkey=7yvsba510fyeufi8cjea9juqk
    answerString?: string;
    // id that groups all queries in a single "session" for logging
    searchSessionId?: string;
    // unique id for a /dash/search query. Used by the ML team to get feedback on search result ranking
    searchRequestId?: string;
    // unique id generated by the server for an assist request. Used by the ML team to link user actions on an assistant response and get feedback on usefulness of the response
    assistRequestId?: string;
    // Identifier for a search query
    // Identifier is a v4 uuid that is generated on the fly during a search.
    searchQueryUuid?: string;
  }
>;

export function PAP_Shown_AssistantResponse(properties?: Shown_AssistantResponse['properties']): Shown_AssistantResponse {
  return <Shown_AssistantResponse>{
    class: 'dash',
    action: 'shown',
    object: 'assistant_response',
    properties,
  };
}
